import React from 'react';
import { Dialog, IconButton, Typography, Box, Button } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import popupStyles from '../../styles/kozelDarkQuiz/popup';
import barcodeImg from '../../assets/images/bicycle_game/barcode-aztec-crem.png';

interface PersonalityType {
  type: string;
  description: string;
  ritual: string;
}

interface PopupProps {
  open: boolean;
  onClose: () => void;
  personalityType?: PersonalityType | null;
}

const Popup: React.FC<PopupProps> = ({ open, onClose, personalityType }) => {
  const classes = popupStyles();

  // Default values if no personality type is provided
  const defaultPersonality = {
    type: "HONEY CRUST",
    description: "Ai mereu chef de ceva nou, te arunci cu zâmbetul înainte și îți place când viața are puțină glazură pe margine.",
    ritual: "cel care face prima impresie memorabilă"
  };

  const personality = personalityType || defaultPersonality;

  const PDF_PATH = '/pdf/qr kauf.pdf';

  const downloadPdf = async (url: string, filename?: string) => {
    try {
      const res = await fetch(encodeURI(url));
      if (!res.ok) throw new Error(`Network response was not ok: ${res.status}`);
      const blob = await res.blob();
      const blobUrl = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = blobUrl;
      a.download = filename || (url.split('/').pop() || 'voucher.pdf');
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(blobUrl);
    } catch (err) {
      console.error('Download failed, opening in new tab as fallback:', err);
      window.open(url, '_blank');
    }
  };

  return (
    <Dialog open={open} onClose={onClose} classes={{ paper: classes.dialogPaper }}>
      {/* Buton închidere */}
      <IconButton onClick={onClose} className={classes.closeButton}>
        <CloseIcon fontSize="large" />
      </IconButton>

      {/* Titlu */}
      <Typography variant="h4" align="center" className={classes.title}>
        ȚAPĂN!
      </Typography>
      <Typography variant="h5" align="center" className={classes.subtitle}>
        EȘTI..... <span className={classes.highlight}>{personality.type}!</span>
      </Typography>

      {/* Text */}
      <Typography variant="body1" align="center" className={classes.description}>
        {personality.description}
        <span className={classes.boldHighlight}> Ritualul tău: {personality.ritual}. Ai stil. Ai ritual.</span>
      </Typography>
      {/* Original: <span className={classes.boldHighlight}> Ritualul tău: {personality.ritual}. Ai stil. Ai ritual. Ai și 20% reducere la Kozel.</span> */}

      {/* Instrucțiuni */}
      {/* <Typography variant="body2" align="center" className={classes.instructions}>
        Activează voucherul mai jos și fă-i loc în frigider.
      </Typography>
      <Typography variant="caption" align="center" display="block" className={classes.caption}>
        Fă captură voucher-elor de 20% discount și prezintă-le la casa de marcat. Sau descarcă pdf-ul cu voucher-ul și
        prezintă-l la casa de marcat pentru a fi scanat.
      </Typography> */}

      {/* Vouchere */}
      {/* <Box className={classes.voucherContainer}>
        <Box className={classes.voucherBox}>
          <img src={barcodeImg} alt="Voucher QR" className={classes.qrImage} />
          <Button
            className={classes.voucherButton}
            onClick={() => downloadPdf(PDF_PATH, 'voucher_mega.pdf')}
          >
            DESCARCĂ VOUCHER (PDF)<br />MEGA IMAGE
          </Button>
        </Box>
        <Box className={classes.voucherBox}>
          <img src={barcodeImg} alt="Voucher QR" className={classes.qrImage} />
          <Button
            className={classes.voucherButton}
            onClick={() => downloadPdf(PDF_PATH, 'voucher_profi.pdf')}
          >
            DESCARCĂ VOUCHER (PDF)<br />PROFI
          </Button>
        </Box>
        <Box className={classes.voucherBox}>
          <img src={barcodeImg} alt="Voucher QR" className={classes.qrImage} />
          <Button
            className={classes.voucherButton}
            onClick={() => downloadPdf(PDF_PATH, 'voucher_kaufland.pdf')}
          >
            DESCARCĂ VOUCHER (PDF)<br />KAUFLAND
          </Button>
        </Box>
      </Box> */}
    </Dialog>
  );
};

export default Popup;